import React from "react";
import Routers from "./Common/Routes/Routes";

export default function main(props) {
  return <Routers />;
}
